/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */
import { SphereGeometry, TorusGeometry, MeshPhongMaterial, MeshToonMaterial, Mesh, Group, FlatShading, DoubleSide } from 'three'

/**
 * The use of a JavaScript “class” is also a design choice.
 */
class Turtle {
  constructor(color) {
    this.group = new Group()
    this.materials = []

    this.geometry = new SphereGeometry(1, 8, 4, 0, 6.3, 0, 1.1)
    this.shellTopMaterial = new MeshPhongMaterial({ color: 0x434010, shading: FlatShading })
    this.materials.push(this.shellTopMaterial)
    this.shell = new Mesh(this.geometry, this.shellTopMaterial)
    this.shell.rotation.z = -Math.PI / 2;
    this.group.add(this.shell)

    this.geometry = new SphereGeometry(2.3, 8, 4, 0, 6.3, 0, 0.4)
    this.shellBottomMaterial = new MeshPhongMaterial({ color: 0xd2b48c, shading: FlatShading })
    this.materials.push(this.shellBottomMaterial)
    this.belly = new Mesh(this.geometry, this.shellBottomMaterial)
    this.belly.rotation.x = Math.PI / 2;
    this.belly.rotation.z = Math.PI / 2;
    this.belly.position.x = 2.58;
    this.group.add(this.belly)

    this.eyeMaterial = new MeshToonMaterial({ color: 0x0 })
    this.materials.push(this.eyeMaterial)
    this.geometry = new SphereGeometry(0.05, 5, 5)
    this.rightEye = new Mesh(this.geometry, this.eyeMaterial)
    this.rightEye.rotation.x = Math.PI / 2;
    this.rightEye.position.set(0.6, 0.25, 1.15);
    this.group.add(this.rightEye)

    this.geometry = new SphereGeometry(0.05, 5, 5)
    this.leftEye = new Mesh(this.geometry, this.eyeMaterial)
    this.leftEye.rotation.x = Math.PI / 2;
    this.leftEye.position.set(0.6, -0.25, 1.15);
    this.group.add(this.leftEye)

    this.skinMaterial = new MeshToonMaterial({ color: 0x265926 })
    this.skinMaterial.side = DoubleSide;
    this.materials.push(this.skinMaterial)

    this.geometry = new SphereGeometry(0.3, 12, 12)
    this.head = new Mesh(this.geometry, this.skinMaterial)
    this.head.rotation.x = Math.PI / 2;
    this.head.position.set(0.5, 0, 1);
    this.group.add(this.head)

    this.frontRight = new Group()
    this.frontLeft = new Group()
    this.backRight = new Group()
    this.backLeft = new Group()

    this.group.add(this.frontRight)
    this.group.add(this.frontLeft)
    this.group.add(this.backRight)
    this.group.add(this.backLeft)

    this.geometry = new TorusGeometry(0.7, 0.1, 6, 6, 2)

    this.frontRightFlipper = new Mesh(this.geometry, this.skinMaterial)
    this.frontRightFlipper.rotation.y = Math.PI / 2;
    this.frontRightFlipper.rotation.x = Math.PI / 1.5;
    this.frontRightFlipper.position.set(0.5, -0.7, 0);
    this.frontRight.add(this.frontRightFlipper)

    this.frontLeftFlipper = new Mesh(this.geometry, this.skinMaterial)
    this.frontLeftFlipper.rotation.y = Math.PI / 2;
    this.frontLeftFlipper.rotation.x = Math.PI / 1.5;
    this.frontLeftFlipper.position.set(0.5, 0.75, 0);
    this.frontLeft.add(this.frontLeftFlipper)

    this.geometry = new TorusGeometry(0.7, 0.1, 6, 6, 1.3)

    this.backRightFlipper = new Mesh(this.geometry, this.skinMaterial)
    this.backRightFlipper.rotation.y = Math.PI / 2;
    this.backRightFlipper.rotation.x = Math.PI / 2.3;
    this.backRightFlipper.position.set(0.5, -0.3, -1);
    this.backRight.add(this.backRightFlipper)

    this.backLeftFlipper = new Mesh(this.geometry, this.skinMaterial)
    this.backLeftFlipper.rotation.y = Math.PI / 2;
    this.backLeftFlipper.rotation.x = -Math.PI / 1.2;
    this.backLeftFlipper.position.set(0.5, 0.3, -1);
    this.backLeft.add(this.backLeftFlipper)

    this.geometry = new SphereGeometry(0.1, 6, 6)

    this.frontRightFlipperEnd = new Mesh(this.geometry, this.skinMaterial)
    this.frontRightFlipperEnd.position.set(0.5, -1.27, 0.4);
    this.frontRight.add(this.frontRightFlipperEnd)

    this.frontLeftFlipperEnd = new Mesh(this.geometry, this.skinMaterial)
    this.frontLeftFlipperEnd.position.set(0.5, 1.34, 0.36);
    this.frontLeft.add(this.frontLeftFlipperEnd)

    this.backRightFlipperEnd = new Mesh(this.geometry, this.skinMaterial)
    this.backRightFlipperEnd.position.set(0.5, 0.383, -1.145);
    this.backRight.add(this.backRightFlipperEnd)

    this.backLeftFlipperEnd = new Mesh(this.geometry, this.skinMaterial)
    this.backLeftFlipperEnd.position.set(0.5, -0.383, -1.145);
    this.backLeft.add(this.backLeftFlipperEnd)
  }
}

export default Turtle
